import apiCall, { apiUserCall } from 'apps/investment/apiCalls/user';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { CreatePage, EditPage } from 'common/ui/AdminCRUD/page';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { Button } from 'common/ui/button';
import { CirclePlus } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import ItemForm from './Form';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

export const InvestmentUserListPage = () => {
  const renderRightHeader = () => {
    return (
      <Button
        asChild
        variant="outline"
        size="icon"
        className="relative border-2 border-primary bg-white hover:bg-gray-100"
        aria-label={'user create'}
      >
        <Link to={`/investment/users/create`}>
          <CirclePlus className="text-primary" strokeWidth={3} />
        </Link>
      </Button>
    );
  };
  return (
    <ListPage
      title="All User Accounts"
      columnsGenerator={columnsGenerator}
      apiCall={apiUserCall}
      FilterForm={() => <DynamicFilterForm fields={filterConfig} />}
      renderRightHeader={renderRightHeader}
    />
  );
};

export const InvestmentUserEditPage = props => {
  const { id } = useParams();

  return (
    <EditPage
      title="User"
      apiCall={apiCall}
      listUrl={`/investment/users/${id}`}
      ItemForm={ItemForm}
      options={{ title: 'Edit account info' }}
      resourceName="data"
      {...props}
    />
  );
};

export const InvestmentUserDetailPage = props => {
  return (
    <DetailPage
      title="Stag User"
      apiCall={apiUserCall}
      listUrl={`/investment/users`}
      ItemDetail={ItemDetail}
      options={{ editEnabled: false }}
      {...props}
    />
  );
};

export const InvestmentUserCreatePage = props => (
  <CreatePage
    title="User"
    apiCall={apiCall}
    listUrl={`/investment/users`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);
